var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back-icon-img",
    transform: "translate(4838 5301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-back-img",
    d: "M-1704.016-3128.258a1.816,1.816,0,0,1-1.118-.384l-5.423-4.215a1.824,1.824,0,0,1-.7-1.428,1.824,1.824,0,0,1,.686-1.437l5.423-4.33a1.824,1.824,0,0,1,2.564.287,1.824,1.824,0,0,1-.287,2.563l-3.614,2.886,3.595,2.794a1.824,1.824,0,0,1,.321,2.56A1.821,1.821,0,0,1-1704.016-3128.258Z",
    transform: "translate(-3123.067 -2157.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 18,
    height: 18,
    transform: "translate(-4838 -5301)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconImg);
export default __webpack_public_path__ + "static/media/back-icon-img.cda6f7893f8a1842054eeea980a62223.svg";
export { ForwardRef as ReactComponent };